'use strict'

var regexCheck = require('../util/regex-check.js')

var asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/)

module.exports = asciiAtext



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/character/ascii-atext.js
// module id = 1496
// module chunks = 0